import React from 'react';
import HorizontalBarChart from '../../../shared/horizontalBarChart';
import { Box,Skeleton,Typography } from '@mui/material';
import { useSelector } from 'react-redux';
const DtcTopCityChart = () => {
    const { dtcData } = useSelector((state) => state.webMatrix);
    const { isWebMatrixPatientLoading,topCitiesChartData } = dtcData;
    const { series, categories } = topCitiesChartData;
      
    const options = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: { show: false }
        },
        colors: [
            '#C76EBA',
            '#8C3F7D'
        ],
        plotOptions: { bar: { horizontal: true } },
        stroke: {
            width: 1,
            colors: ['#fff']
        },
        xaxis: { categories: categories },
        tooltip: {
            y: {
                formatter: function (val) {
                    return val; // Displays raw counts
                }
            }
        },
        fill: { opacity: 1 },
        legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
        }
    };

    return (
        <Box className="container-p-24-br-16 bg-gray-50">
            <Box>
                <Typography className="text-md-medium gray-900">
                     Engagement By Top 10 Cities
                </Typography>
            </Box>
            {
                isWebMatrixPatientLoading ? <Skeleton height={400} variant="rectangular" width='100%'/> :
                    <HorizontalBarChart chartOptions={options} chartSeries={series} />
            }
        </Box>
        
    );
};

export default DtcTopCityChart;
